import OrganizationSlice from './Redux/OrganizationSlice';
import ProcedureReducer from './Redux/ProcedureReducer';

import { configureStore } from '@reduxjs/toolkit';
import OauthSlice from './Redux/OauthSlice';
import UserSlice from './Redux/UserSlice';
import RoleSlice from './Redux/RoleSlice';
import FolderSlice from './Redux/FolderSlice';

const store = configureStore({
  reducer: {
    Procedure: ProcedureReducer,
    Organization: OrganizationSlice,
    User: OauthSlice,
    Users: UserSlice,
    Roles: RoleSlice,
    Folder: FolderSlice,
  },
});
export default store;
